import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Client } from "src/app/models/clients/clients";
import {
  OptionView,
  ProductView,
} from "src/app/models/products/products";
import {
  ClientTransaction,
  ClientTransactionView,
  DynamicOptionResponse,
  UserAnswer,
} from "src/app/models/products/transactions";
import { TransactionsService } from "src/app/services/transactions.service";
import { Location } from "@angular/common";
import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";
import {
  ClientTransactionForm,
  ClientTransactionViewForm,
  UserAnswerForm,
} from "src/app/models/forms/transactions-form";
import { ClientForm } from "src/app/models/forms/clients-form";

@Injectable({
  providedIn: "root",
})
export class ProductDetailsUiStateService {
  readonly DECIMAL_RULE = '.0-2';
  productView: ProductView;
  chosenOption: OptionView;
  currentOptionIndex = 0;
  
  clientTransactionViewForm: FormGroup<ClientTransactionViewForm>;
  markedFields = [false, false, false, false, false, false];
  displayCurrentPic = false;
  currentPic = "1.jpg";
  displayCommentForm = false;
  isFullOpacity = false;
  stars: number = 0;

  testFields = [false, false, false];
  errorMsg = "אחד או יותר מהקבצים שהוספת לא תקין";
  files = [];
  activeStages = [true, false, false];
  currentStep = 0;

  clientTransaction: ClientTransaction;
  userAnswers: Array<UserAnswer>;
  displayGeneralComment = false;
  filesSrcBase64 = [];
  productId: number;
  currentUrl: string;

  get clientTransactionForm(): AbstractControl<ClientTransactionForm> {
    return this.clientTransactionViewForm.get(['ClientTransaction']);
  }

  get apartmentSize(): AbstractControl<number>{
    return this.clientTransactionForm.get(['ApartmentSize']);
  }

  get timeToGetProgramInDays(): AbstractControl<number>{
    return this.clientTransactionForm.get(['TimeToGetProgramInDays']);
  }

  get existFileFormat(): AbstractControl<string>{
    return this.clientTransactionForm.get(['ExistFileFormat']);
  }

  get wantedFileFormat(): AbstractControl<string>{
    return this.clientTransactionForm.get(['WantedFileFormat']);
  }

  get fixesTimes(): AbstractControl<number>{
    return this.clientTransactionForm.get(['FixesTimes']);
  }

  get dynamicOptionResponses(): FormArray{
    return this.clientTransactionViewForm.get(['DynamicOptionResponses']) as FormArray;
  }

  get isForOperate(): AbstractControl{
    return this.clientTransactionForm.get('IsForOperate');
  }

  get userComment(): AbstractControl{
    return this.clientTransactionForm.get('UserComment');
  }

  get finalPrice(): AbstractControl{
    return this.clientTransactionForm.get('FinalPrice');
  }

  get OriginalPrice(): AbstractControl{
    return this.clientTransactionForm.get('OriginalPrice');
  }


  readonly maxFileSize = 50000000; // 50mb
  readonly maxFilesSizeCombined = 500000000; // 500mb
  readonly allowedFileTYpes = [
    "pdf",
    "jpg",
    "png",
    "dwg",
    "jpeg",
    "zip",
    "rar",
  ];
  constructor(
    private _router: Router,
    private _transactionsService: TransactionsService,
    private location: Location
  ) {}

  createForm(): void {
    this.clientTransactionViewForm = new FormGroup<ClientTransactionViewForm>({
      ClientTransaction: new FormGroup<ClientTransactionForm>({
        Id: new FormControl<number>(0),
        ProductOptionId: new FormControl<number>(0),
        ClientId: new FormControl<number>(0),
        FixesTimes: new FormControl<number>(0),
        IsForOperate: new FormControl<boolean>(false),
        ApartmentSizeTypeTxt: new FormControl<string>(""),
        ApartmentSize: new FormControl<number>(0),
        ExistFileFormat: new FormControl<string>(""),
        WantedFileFormat: new FormControl<string>(""),
        TimeToGetProgramInDays: new FormControl<number>(0),
        GetDWGFile: new FormControl<boolean>(false),
        UniqIdForPay: new FormControl<string>(""),
        IsUnsuccessMailSendToUser: new FormControl<boolean>(false),
        UserComment: new FormControl<string>(""),
        CouponCode: new FormControl<string>(""),
        IsUserPayedForTransaction: new FormControl<boolean>(false),
        TimeUserPayedForTransaction: new FormControl<string>(""),
        FinalPrice: new FormControl<number>(0),
        OriginalPrice: new FormControl<number>(0),
        AdminComments: new FormControl<string>(""),
        AdminCommentsObj: new FormArray<
          FormGroup<{ created: FormControl<Date>; data: FormControl<string> }>
        >([]),
        Created: new FormControl<string>(""),
        Updated: new FormControl<string>(""),
        Active: new FormControl<boolean>(true),
      }),
      Client: new FormGroup<ClientForm>({
        Id: new FormControl<number>(0),
        FName: new FormControl<string>(""),
        LName: new FormControl<string>(""),
        Phone: new FormControl<string>(""),
        Email: new FormControl<string>(""),
        Address: new FormControl<string>(""),
        Created: new FormControl<string>(""),
        Updated: new FormControl<string>(""),
        Active: new FormControl<boolean>(true),
      }),
      ProdName: new FormControl<string>(""),
      UserAnswers: new FormArray<FormGroup<UserAnswerForm>>([]),
      captchaResponse: new FormControl<string>(""),
      CouponId: new FormControl<number>(0),
      DynamicOptionResponses: new FormArray([]),
    });
  }

  resetData(): void {
    this.currentOptionIndex = 0;
    this.markedFields = [false, false, false, false, false, false];
    this.displayCurrentPic = false;
    this.currentPic = "1.jpg";
    this.displayCommentForm = false;
    this.isFullOpacity = false;
    this.stars = 0;
    this.displayGeneralComment = false;
    this.testFields = [false, false, false];
    this.errorMsg = "אחד או יותר מהקבצים שהוספת לא תקין";
    this.files = [];
    this.activeStages = [true, false, false];
    this.currentStep = 0;
  }

  displayCurrentPicChange(val: boolean): void {
    this.displayCurrentPic = val;
  }

  currentPicChange(path: string): void {
    this.currentPic = path;
  }

  displayCommentFormChange(val: boolean): void {
    this.displayCommentForm = val;
  }

  changeFullOpacityState(): void {
    this.isFullOpacity = !this.isFullOpacity;
  }

  starsChange(stars: number): void {
    this.stars = stars;
    this.displayCommentForm = true;
    this.changeFullOpacityState();
    document.querySelector(".anim-to-disable")?.classList.add("disable-anim");
  }

  GoToBasket(transactionIndex: number): void {
    if (this.checkValidity()) {
      this.addProductToBasket(transactionIndex);
      this._router.navigate(["/aoc/archonline_basket"]);
    }
  }

  backToStageOne(): void {
    this.activeStages[0] = true;
    this.activeStages[1] = false;
    this.currentStep = 0;
  }

  checkValidity(): boolean {
    let res = true;
    this.testFields = [false, false, false];
    this.errorMsg = "";
    let filesSize = 0;
    if (this.files != null) {
      for (let i = 0; i < this.files.length; i++) {
        const fileExt = this.files[i].name.split(".").pop().toLowerCase();
        filesSize += this.files[i].size;
        if (this.files[i].size > this.maxFileSize) {
          this.testFields[2] = true;
          res = false;
          this.errorMsg = `הגודל של אחד מהקבצים שהוספת (${i}) גדול מידי. מקסימום גודל קובץ ${
            this.maxFileSize / 1000000
          }MB`;
        } else if (this.allowedFileTYpes.indexOf(fileExt) < 0) {
          this.testFields[2] = true;
          res = false;
          this.errorMsg = `סוג הקובץ ${fileExt} לא תקין. סוגי הקבצים המותרים: `;
          this.allowedFileTYpes.forEach((item) => {
            this.errorMsg += item + " ";
          });
        }
      }
    }
    if (filesSize > this.maxFilesSizeCombined) {
      this.testFields[2] = true;
      res = false;
      this.errorMsg = `לא ניתן להעביר קבצים בנפח כולל של יותר מ-${
        this.maxFilesSizeCombined / 1000000
      }MB`;
    }
    if (res === false) {
      const offset =
        document.querySelector(".scroll-input")[this.testFields.indexOf(true)]
          .offsetTop + 120;
      document.getElementsByTagName("html")[0].scrollTop = offset;
      document
        .querySelector(".valid-focus")
        [this.testFields.indexOf(true)].focus();
    }
    return res;
  }

  addProductToBasket(transactionIndex: number = null): void {
    const clientTransactionView = this.generateClientTransaction();
    if (transactionIndex) {
      this._transactionsService.clientTransactionsView$.getValue()[
        transactionIndex
      ] = clientTransactionView;
      this._transactionsService.fileList.data.items[transactionIndex] =
        this.files;
    } else {
      this._transactionsService.clientTransactionsView$
        .getValue()
        .push(clientTransactionView);
      if (this.files.length > 0) {
        this._transactionsService.fileList.data.items[
          this._transactionsService.clientTransactionsView$.getValue().length -
            1
        ] = this.files;
      } else {
        this._transactionsService.fileList.data.items[
          this._transactionsService.clientTransactionsView$.getValue().length -
            1
        ] = [];
      }
    }
    this._transactionsService.saveClientTransactionToLocalStorage();
  }

  generateClientTransaction(): ClientTransactionView {
    const client = new Client();
    client.Address = "";
    client.Email = "";
    client.FName = "";
    client.LName = "";
    client.Phone = "";
    this.clientTransaction = new ClientTransaction();
    this.clientTransaction.ApartmentSize = this.apartmentSize.value;
    this.clientTransaction.ApartmentSizeTypeTxt =
      this.chosenOption.ProductOptionItem.ApartmentSizeTypeTxt;
    this.clientTransaction.ExistFileFormat = this.existFileFormat.value;
    this.clientTransaction.FixesTimes = this.fixesTimes.value;
    this.clientTransaction.WantedFileFormat =this.wantedFileFormat.value;
    this.clientTransaction.IsForOperate = this.isForOperate.value;
    this.clientTransaction.TimeToGetProgramInDays = this.timeToGetProgramInDays.value;
    this.clientTransaction.UserComment = this.userComment.value;
    this.clientTransaction.ProductOptionId =
      this.chosenOption.ProductOptionItem.Id;
    this.clientTransaction.FinalPrice = this.finalPrice.value;
    this.clientTransaction.OriginalPrice = this.OriginalPrice.value;
    if (
      this.wantedFileFormat?.value=== 'DWG'
    ) {
      this.clientTransaction.GetDWGFile = true;
    }
    const clientTransactionView = new ClientTransactionView();
    clientTransactionView.ClientTransaction = this.clientTransaction;
    clientTransactionView.Client = client;
    clientTransactionView.ProdName = this.productView.ProductItem.Name;
    clientTransactionView.UserAnswers = this.userAnswers;
    clientTransactionView.DynamicOptionResponses = this.clientTransactionViewForm.get('DynamicOptionResponses').value;
    return clientTransactionView;
  }

  continueOrder(step: number, transactionIndex: number): void {
    let res = false;
    if (step === 1 && this.validateHouseSize()) {
      res = true;

      const id = this.productId;
      const trnsIndex = transactionIndex ? transactionIndex + "/" : "";
      const str =
        "/p/product2/" +
        id +
        "/" +
        trnsIndex +
        this.productView.ProductItem.Name.replace(new RegExp(" ", "g"), "-");
      this.updateFilePictures();
      const url = this._router.createUrlTree([str]).toString();

      this.location.go(url);
    } else if (step !== 1) {
      res = true;
    }
    if (res) {
      for (let i = 0; i < this.activeStages.length; i++) {
        this.activeStages[i] = false;
      }
      this.activeStages[step] = true;
      this.currentStep = step;
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (step === 1) {
        this.OriginalPrice.setValue(this.finalPrice.value);
      }
    }
  }

  validateHouseSize(): boolean {
    this.testFields[0] = false;
    let res = true;
    if (
      this.existFileFormat?.value &&
      (this.existFileFormat.value.toLowerCase() === "pdf" ||
      this.existFileFormat.value.toLowerCase() === "jpg")
    ) {
      if (this.apartmentSize.value === 0) {
        res = false;
        this.testFields[1] = true;
      }
    }
    return res;
  }

  updateFilePictures(): void {
    this.filesSrcBase64 = [];
    if (this.files) {
      for (let i = 0; i < this.files.length; i++) {
        const reader = new FileReader();
        reader.readAsDataURL(this.files[i]);
        reader.onload = () => {
          this.filesSrcBase64.push(reader.result);
        };
      }
    }
  }

  setSelectedDynamicOptions(): void {
    this.dynamicOptionResponses.clear();
    this.chosenOption.DynamicProductOptions.forEach((item) => {
      const dynamicOptionResponse = new FormControl<DynamicOptionResponse>(
        {
          Id: -1,
          DynamicOptionItemId: item.DynamicProductOptionItems[0]?.Id,
          OptionId: item.OptionId,
          Label: item.OptionTitle,
          Value: item.DynamicProductOptionItems[0]?.Label,
          Price: item.DynamicProductOptionItems[0]?.Price,
          TransactionId: 0,
          Created: null,
          Updated: null,
          Active: true,
        })
      ;
      this.dynamicOptionResponses.push(dynamicOptionResponse);
    });

  }

  setExistDynamicOptions(trnsIndex: number): void {
    this.dynamicOptionResponses.clear();
    this._transactionsService.clientTransactionsView$.getValue()[
      trnsIndex
    ].DynamicOptionResponses.forEach((item) => {
      const dynamicOptionResponse = new FormControl<DynamicOptionResponse>(
        {
          Id: item.Id,
          DynamicOptionItemId: item.DynamicOptionItemId,
          OptionId: item.OptionId,
          Label: item.Label,
          Value: item.Value,
          Price: item.Price,
          TransactionId: item.TransactionId,
          Created: item.Created,
          Updated: item.Updated,
          Active: item.Active,
        })
      ;
      this.dynamicOptionResponses.push(dynamicOptionResponse);
    });
  }

  
  addToFinalPrice(): void {
    let dynamicOptionPrice = 0;
    this.dynamicOptionResponses.value.forEach((item) => {
      dynamicOptionPrice += item.Price;
    });
    let finalPrice = this.chosenOption.ProductOptionItem.BaseOptionPrice;
    
    const dayPrice = this.getSelectedDayPrice();
    const existFileFormatPrice = this.getSelectedExistFileFormatPrice();
    const wantedFileFormatPrice = this.getSelectedWantedFileFormatPrice();
    const fixTimePrice = this.getSelectedFixTimePrice();

    finalPrice +=
    fixTimePrice
        ? fixTimePrice
        : 0;
    finalPrice +=
      dayPrice
        ? dayPrice
        : 0;
    finalPrice +=
    existFileFormatPrice
        ? existFileFormatPrice * this.apartmentSize.value
        : 0;
    finalPrice +=
    wantedFileFormatPrice
        ? wantedFileFormatPrice
        : 0;
    finalPrice += dynamicOptionPrice;
    this.finalPrice.setValue(finalPrice);
  }


  getSelectedDayPrice(): number{
    const dayAndPricesObj = this.chosenOption.DayAndPricesItems.find(x=>x.Days===parseInt(this.timeToGetProgramInDays?.value?.toString()));
    return dayAndPricesObj?.PricePerDays || 0;
  }

  getSelectedExistFileFormatPrice(): number{
    const existFileFormatObj = this.chosenOption.ExistFileFormatItems.find(x=>x.FormatName===this.existFileFormat.value);
    return  existFileFormatObj?.Price|| 0;
  }

  getSelectedWantedFileFormatPrice(): number{
    const wantedFileFormatObj = this.chosenOption.AvailableFileFormatItems.find(x=>x.FormatName===this.wantedFileFormat.value);
    return wantedFileFormatObj?.Price|| 0;
  }

  getSelectedFixTimePrice(): number{
    const fixTimeObj = this.chosenOption.FixesPricesItems.find(x=>x.NumberOfFixes===parseInt(this.fixesTimes.value?.toString() ));
    return fixTimeObj?.Price || 0;
  }

  getSelectedDynamicFieldPrice(dynamicOptionIndex: number): number{
    if(this.clientTransactionViewForm.get(['DynamicOptionItems', dynamicOptionIndex, 'DynamicOptionItemId'])){
      const dynamicOptionItemIndex =this.chosenOption.DynamicProductOptions[dynamicOptionIndex].DynamicProductOptionItems.findIndex(x=>x.Id===    this.clientTransactionViewForm.get(['DynamicOptionItems', dynamicOptionIndex, 'DynamicOptionItemId']).value);    
      return dynamicOptionItemIndex>-1?this.chosenOption.DynamicProductOptions[dynamicOptionIndex].DynamicProductOptionItems[dynamicOptionItemIndex].Price: 0;
    }
   return 0; 
  }

  updateFields(): void {
    this.finalPrice.setValue(this.chosenOption.ProductOptionItem.BaseOptionPrice);
    this.isForOperate.setValue(
      this.chosenOption.ProductOptionItem.IsForOperate);
    this.existFileFormat.setValue(
      this.chosenOption.ExistFileFormatItems[0]?.FormatName);
    this.wantedFileFormat.setValue(
      this.chosenOption.AvailableFileFormatItems[0]?.FormatName);
    this.OriginalPrice.setValue(this.finalPrice.value);
    this.setSelectedDay();
    this.setSelectedAvailableFile();
    this.setSelectedExistFile();
    this.setSelectedFixPrice();
    this.setSelectedDynamicOptions();
    this.addToFinalPrice();
  }

  setSelectedDay(): void {
    for (const item of this.chosenOption.DayAndPricesItems) {
      if (item.IsDefault) {
        this.timeToGetProgramInDays.setValue(item.Days);
      }
    }
  }

  setSelectedAvailableFile(): void {
    for (const item of this.chosenOption.AvailableFileFormatItems) {
      if (item.IsDefault) {
        this.wantedFileFormat.setValue(item.FormatName);
      }
    }
  }

  setSelectedExistFile(): void {
    for (const item of this.chosenOption.ExistFileFormatItems) {
      if (item.IsDefault) {
        this.existFileFormat.setValue(item.FormatName);
      }
    }
  }

  setSelectedFixPrice(): void {
    for (const item of this.chosenOption.FixesPricesItems) {
      if (item.IsDefault) {
        this.fixesTimes.setValue(item.NumberOfFixes);
      }
    }
  }

  uploadFiles(files): void {
    for (let i = 0; i < files.length; i++) {
      if (!this.files) {
        this.files = [];
      }
      this.files.push(files[i]);
      const fileExt = files[i].name.split(".").pop().toLowerCase();
      if (
        fileExt === "dwg" ||
        fileExt === "pdf" ||
        fileExt === "rar" ||
        fileExt === "zip"
      ) {
        this.filesSrcBase64.push(fileExt);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = () => {
          this.filesSrcBase64.push(reader.result);
        };
      }
    }
  }
}
